import { render, staticRenderFns } from "./labelled-checkbox.vue?vue&type=template&id=0893a472&scoped=true&"
import script from "./labelled-checkbox.vue?vue&type=script&lang=js&"
export * from "./labelled-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./labelled-checkbox.vue?vue&type=style&index=0&id=0893a472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893a472",
  null
  
)

export default component.exports